export const CLOSE_COOKIES_MODAL = 'CLOSE_COOKIES_MODAL'

export const closeCookiesModal = () => dispatch =>
  dispatch({
    type: CLOSE_COOKIES_MODAL,
  })
